import garbage from "./garbage.png";
import edit from "./edit.png";
import tick from "./tick.png";
import minus from "./minus.png";
import clipboard from "./clipboard.png";
import plus from "./plus.png";
import cross from "./cross.png";
import ownerDemo from "./owner-demo.png";
import participantDemo from "./participant-demo.png";
import ownerDemoV2 from "./owner-demo-2.png";
import participantDemoV2 from "./participant-demo-2.png";
import shown from "./shown.png";
import hidden from "./hidden.png";
import downArrow from "./down-arrow.png";
import lock from "./lock.png";
import check from "./check.png";

const images = {
  garbage,
  edit,
  tick,
  minus,
  clipboard,
  plus,
  cross,
  ownerDemo,
  participantDemo,
  ownerDemoV2,
  participantDemoV2,
  shown,
  hidden,
  downArrow,
  lock,
  check,
};

export default images;
